import { OrderListDesignTokens } from '@primeuix/themes/types/orderlist';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/orderlist/index.ts
const ol = componentCommon.orderlist;

export const OrderlistTelekomDT: OrderListDesignTokens = {
  root: {
    gap: t(ol.gap),
  },
  controls: {
    gap: t(ol.controls.gap),
  },
};
